var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import device from '../../styleguide/styles/device';
export var TextBoxStyleType;
(function (TextBoxStyleType) {
    TextBoxStyleType[TextBoxStyleType["Standard"] = 0] = "Standard";
    TextBoxStyleType[TextBoxStyleType["Big"] = 1] = "Big";
})(TextBoxStyleType || (TextBoxStyleType = {}));
var StyledTextBox = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  @media ", " {\n    font-size: ", "px;\n  }\n\n  font-family: ", ";\n  margin: 0.5rem 0;\n  padding: 0.75rem 1rem;\n  border: 1px solid\n    ", ";\n  border-radius: 5px;\n  box-sizing: border-box;\n  letter-spacing: 2px;\n  width: ", ";\n"], ["\n  background: ", ";\n  color: ", ";\n  font-weight: ",
    ";\n  font-size: ",
    "px;\n  @media ", " {\n    font-size: ",
    "px;\n  }\n\n  font-family: ",
    ";\n  margin: 0.5rem 0;\n  padding: 0.75rem 1rem;\n  border: 1px solid\n    ",
    ";\n  border-radius: 5px;\n  box-sizing: border-box;\n  letter-spacing: 2px;\n  width: ", ";\n"])), function (props) { return props.theme.colors.surface; }, function (props) { return props.theme.colors.secondary; }, function (props) {
    switch (props.styleType) {
        case TextBoxStyleType.Standard:
            return 400;
        case TextBoxStyleType.Big:
            return 700;
    }
}, function (props) {
    switch (props.styleType) {
        case TextBoxStyleType.Standard:
            return 16;
        case TextBoxStyleType.Big:
            return 28;
    }
}, device.maxMobileS, function (props) {
    switch (props.styleType) {
        case TextBoxStyleType.Standard:
            return 16;
        case TextBoxStyleType.Big:
            return 20;
    }
}, function (props) {
    switch (props.styleType) {
        case TextBoxStyleType.Standard:
            return props.theme.fonts.secondary;
        case TextBoxStyleType.Big:
            return props.theme.fonts.main;
    }
}, function (props) {
    if (props.hasError)
        return props.theme.colors.error;
    else
        return props.theme.colors.secondaryvarient;
}, function (props) { var _a; return _a = props.width, (_a !== null && _a !== void 0 ? _a : '100%'); });
function TextBox(_a) {
    var _b = _a.styleType, styleType = _b === void 0 ? TextBoxStyleType.Standard : _b, props = __rest(_a, ["styleType"]);
    return (React.createElement(StyledTextBox, __assign({ hasError: props.hasError, styleType: styleType }, props, { "aria-label": props.label })));
}
export default TextBox;
var templateObject_1;
